import { useTownChannelList } from '@components/TownPageLayout/hooks/useSpacePageChannels'
import { Box, Divider, Icon, Stack, Text } from '@ui'
import { useChannelEntitlements } from 'hooks/useChannelEntitlements'

type Props = {
    spaceId: string | undefined
}

export const TownChannelList = ({ spaceId }: Props) => {
    const { channels, channelCount, isLoading: isChannelsLoading } = useTownChannelList(spaceId)
    const MAX_VISIBLE_CHANNELS = 8

    const visibleChannels = channels.slice(0, MAX_VISIBLE_CHANNELS)
    const remainingCount = channels.length - MAX_VISIBLE_CHANNELS

    if (!spaceId || channels.length === 0 || isChannelsLoading) {
        return null
    }

    return (
        <>
            <Divider />
            <Stack gap="md" maxWidth="500">
                <Text strong fontSize="lg" size="md">
                    {channelCount} Channel{channelCount === 1 ? '' : 's'}
                </Text>
                <Stack horizontal flexWrap="wrap" gap="sm">
                    {visibleChannels.map((channel) => (
                        <ChannelItem
                            key={channel.channelNetworkId}
                            channel={channel}
                            spaceId={spaceId}
                        />
                    ))}
                    {remainingCount > 0 && (
                        <Box
                            key={`remaining-${remainingCount}`}
                            paddingX="sm"
                            paddingY="sm"
                            borderRadius="sm"
                            style={{
                                border: '1px solid rgba(255, 255, 255, 0.10)',
                            }}
                        >
                            <Text color="gray1">+{remainingCount} more</Text>
                        </Box>
                    )}
                </Stack>
            </Stack>
        </>
    )
}

const ChannelItem = ({
    channel,
    spaceId,
}: {
    channel: { name: string; channelNetworkId: string }
    spaceId: string
}) => {
    const { hasSomeEntitlement } = useChannelEntitlements({
        spaceId,
        channelId: channel.channelNetworkId,
    })

    return (
        <Box border="transparent" paddingX="sm" paddingY="sm" borderRadius="sm">
            <Stack horizontal gap="none" alignItems="center">
                {hasSomeEntitlement ? (
                    <>
                        <Box display="flex" justifyContent="center">
                            <Icon type="lock" size="square_xs" color="gray1" />
                        </Box>
                        <Text color="gray1" style={{ marginLeft: '2px' }}>
                            {channel.name}
                        </Text>
                    </>
                ) : (
                    <>
                        <Box display="flex" justifyContent="center">
                            <Text color="gray1">#</Text>
                        </Box>
                        <Text color="gray1" style={{ marginLeft: '2px' }}>
                            {channel.name}
                        </Text>
                    </>
                )}
            </Stack>
        </Box>
    )
}
